export enum featureToggle {
  'OffersCashbackCap' = 'offers-cashback-cap',
}
